import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import { string, object } from "yup";

translator.getLanguages();

const emailTextRegex = /@[^.]*\./;
const inputTextRegex = /^[a-zа-яё]+$/i;

const schema = object({
	email: string()
		.required(
			translator.t("user", '"{field}" is required', { field: translator.t("main", "Email") })
		)
		.email(translator.t("user", 'The value "E-mail" is not an email address'))
		.matches(
			emailTextRegex,
			translator.t("user", 'The value "E-mail" is not an email address')
		),
	first: string()
		.required(
			translator.t("user", '"{field}" is required', { field: translator.t("user", "First") })
		)
		.min(
			2,
			translator.t("user", 'The value "{field}" must be at least {n} characters ', {
				field: translator.t("user", "First"),
				n: 2,
			})
		)
		.max(
			30,
			translator.t("user", 'The value "{field}" must contain a maximum of {n} characters ', {
				field: translator.t("user", "First"),
				n: "30",
			})
		)
		.matches(
			inputTextRegex,
			translator.t("user", 'The value "{field}" must consist of letters', {
				field: translator.t("user", "First"),
			})
		),
	second: string()
		.required(
			translator.t("user", '"{field}" is required', { field: translator.t("user", "Second") })
		)
		.min(
			2,
			translator.t("user", 'The value "{field}" must be at least {n} characters ', {
				field: translator.t("user", "Second"),
				n: "2",
			})
		)
		.max(
			30,
			translator.t("user", 'The value "{field}" must contain a maximum of {n} characters ', {
				field: translator.t("user", "Second"),
				n: "30",
			})
		)
		.matches(
			inputTextRegex,
			translator.t("user", 'The value "{field}" must consist of letters', {
				field: translator.t("user", "Second"),
			})
		),
	middle: string()
		.max(
			30,
			translator.t("user", 'The value "{field}" must contain a maximum of {n} characters ', {
				field: translator.t("user", "Middle"),
				n: "30",
			})
		)
		.matches(
			inputTextRegex,
			translator.t("user", 'The value "{field}" must consist of letters', {
				field: translator.t("user", "Middle"),
			})
		),
	phone: string()
		.required(
			translator.t("user", '"{field}" is required', { field: translator.t("user", "Phone") })
		)
		.test(
			"len",
			translator.t("user", '"{field}" is required', { field: translator.t("user", "Phone") }),
			val => val.length === 16
		),
	agree: string().test(
		"val",
		translator.t(
			"user",
			'For successful registration, you must check the box "I have read the User Agreement, accept it and give my Consent to the processing of personal data"'
		),
		val => val === "1"
	),
});

export default schema;
